module.exports = __webpack_public_path__ + "assets/img/2.9c73baa6.png";